function Footer() {
  return (
    <footer className="footer">
      <small>
        &copy; 2023&#128030;
        <a
          href="https://lrpoblet.github.io/lara-ramos-poblet"
          target="_blank"
          rel="noreferrer"
          title="Web personal"
        >
          Lara R. Poblet
        </a>
      </small>
      <p>
        <a href="https://rickandmortyapi.com/" target="_blank" rel="noreferrer">
          https://rickandmortyapi.com/
        </a>
      </p>
    </footer>
  );
}
export default Footer;
